import type { TypedString } from 'types/TypedString';

const youtubeVideoIdPattern =
  /(youtu\.be\/|\.com\/v\/|.com\/watch\?v=)([\w-]+)/;

const youtubeLiveVideoIdPattern =
  /(youtu\.be\/|\.com\/v\/|.com\/live\/)([\w-]+)/;

type Props = {
  url: string;
};

export function getYoutubeVideoId({
  url,
}: Props): TypedString<'youtube-video-id'> | undefined {
  if (url.includes('/live/')) return youtubeLiveVideoIdPattern.exec(url)?.[2];

  return youtubeVideoIdPattern.exec(url)?.[2];
}
